import projectPaymentsPricesComponent from './project-payments-prices.component';

const projectPaymentsPricesModule = angular.module('projectPaymentsPrices', [
])
  .component('projectPaymentsPrices', projectPaymentsPricesComponent)
  .name;

export default projectPaymentsPricesModule;
